import dayjs, { Dayjs } from 'dayjs';

import { Nullable } from 'v2/types';

export interface ExportStoreHistoryForm {
  startDate: Nullable<Dayjs>;
  endDate: Nullable<Dayjs>;
}

export const initialValues: ExportStoreHistoryForm = {
  startDate: null,
  endDate: dayjs(),
};
